import { useTranslation } from "react-i18next";

export default function HeaderCatalogSimple(props) {
  const { t } = useTranslation();

  return (

      <span style={{ fontWeight: "bold", fontSize: "18px" }}>{t(props.title)} {props.message}</span>

  );
}
